import { useState, useEffect } from 'react';
import { AdminShell } from '@/components/AdminShell';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import api from '@/lib/api';

export default function AdminContacts() {
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    api.get('/admin/contacts').then(res => setContacts(res.data)).catch(console.error);
  }, []);

  const formatDate = (d) => d ? new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '';

  return (
    <AdminShell title="Messages">
      <p className="font-['Inter'] text-sm text-[hsl(var(--muted-foreground))] mb-6">
        {contacts.length} message{contacts.length !== 1 ? 's' : ''}
      </p>

      <div className="rounded-xl border border-[rgba(201,168,76,0.12)] overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="border-b border-[rgba(201,168,76,0.08)] hover:bg-transparent">
              <TableHead className="font-['Inter'] text-xs font-medium uppercase tracking-[0.12em] text-[hsl(var(--silver))]">From</TableHead>
              <TableHead className="font-['Inter'] text-xs font-medium uppercase tracking-[0.12em] text-[hsl(var(--silver))]">Type</TableHead>
              <TableHead className="font-['Inter'] text-xs font-medium uppercase tracking-[0.12em] text-[hsl(var(--silver))]">Subject</TableHead>
              <TableHead className="font-['Inter'] text-xs font-medium uppercase tracking-[0.12em] text-[hsl(var(--silver))]">Message</TableHead>
              <TableHead className="font-['Inter'] text-xs font-medium uppercase tracking-[0.12em] text-[hsl(var(--silver))]">Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {contacts.length === 0 ? (
              <TableRow><TableCell colSpan={5} className="text-center font-['Inter'] text-sm text-[hsl(var(--muted-foreground))] py-8">No messages yet.</TableCell></TableRow>
            ) : contacts.map(c => (
              <TableRow key={c._id} className="border-b border-[rgba(201,168,76,0.06)] hover:bg-[rgba(27,77,68,0.08)]">
                <TableCell>
                  <p className="font-['Inter'] text-sm text-[hsl(var(--foreground))]">{c.name}</p>
                  <p className="font-['Inter'] text-xs text-[hsl(var(--muted-foreground))]">{c.email}</p>
                </TableCell>
                <TableCell>
                  <Badge variant="outline" className="font-['Inter'] text-[9px] uppercase border-[rgba(168,181,178,0.2)] text-[hsl(var(--silver))]">
                    {c.inquiry_type}
                  </Badge>
                </TableCell>
                <TableCell className="font-['Inter'] text-sm text-[hsl(var(--muted-foreground))]">{c.subject || '—'}</TableCell>
                <TableCell className="font-['Inter'] text-sm text-[hsl(var(--muted-foreground))] max-w-xs truncate">{c.message}</TableCell>
                <TableCell className="font-['Inter'] text-xs text-[hsl(var(--silver))]">{formatDate(c.created_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </AdminShell>
  );
}
